const authPrefix = "auth";
const societyPrefix = "society";
const buildingPrefix = "building";
const accessTypePrefix = "accesstype";
const permissionPrefix = "permission";
const userPrefix = "user";
const complaintPrefix = "complaint";
const userAccessPrefix = "useraccess";
const complaintStatusPrefix = "complaintstatus";
const ratingPrefix = "rating";
const masterLifecyclePrefix = "masterlifecycle";
const complaintLifeCyclePrefix = "complaintlifecycle";
const vendorPrefix = "vendor";
const advanceLevelDataSettingPrefix = "advanceleveldatasetting";
const escalationPrefix = "escalation";
const priorityPrefix = "priority";
const awsPrefix = "aws";
const complaintDeadlinePrefix = "complaintdeadline";
const vendorRatingPrefix = "vendorrating";
const activityPrefix = "activity";
const versionPrefix = "version";
const advanceVendorPrefix = "advancevendor";
const noticePrefix = "notice";
const faqPrefix = "faq"
const contactBookPrefix = "contact"
const misSettingsPrefix = "missetting";
const holidayMappingPrefix = "holiday";
const vendorRatingManualPrefix = "vendorrating";
const ratingColorPrefix = "ratingcolor";
const acknowledgementPrefix = "acknowledgement";
const surveyPrefix = "survey";
const surveyAddressPrefix = "surveyaddress";
const surveyorTargetPrefix = "surveyortarget";

// ** AUTH RELATED ENDPOINTS **
export const AuthEndPoints = {
  login: authPrefix + "/login",
  logout: authPrefix + "/logout",
  verifyUser: authPrefix + "/profile",
  register: authPrefix + "/register",
  verifyOtp: authPrefix + "/verify-credential",
  addPersonalDetails: userPrefix + "/add-details",
  sendOtp: authPrefix + "/send-otp",
  forgotPassword: authPrefix + "/forget-password",
  validateOtp: authPrefix + "/validate-otp",
  resetPassword: authPrefix + "/reset-password",
  addFcmToken: userPrefix + "/add-fcm",

};

// ** VERSION RELATED ENDPOINTS **
export const versionRelatedEndPoints = {
  checkActiveVersion: versionPrefix + "/check-version",
};

// ** SOCIETY RELATED ENDPOINTS **
export const SocietyEndPoints = {
  addSociety: societyPrefix + "/add-society",
  getSocieties: societyPrefix + "/get-all-societies",
  approveOrRejectSociety: societyPrefix + "/approve-society",
  switchSociety: societyPrefix + "/switch-society",
  editSociety: societyPrefix + "/edit-society",
};

// ** LEVEL RELATED ENDPOINTS **
export const LevelEndPoints = {
  getAllLevels: buildingPrefix + "/get-all-levels",
  addLevel: buildingPrefix + "/add-level",
  getLevelDetails: buildingPrefix + "/get-level-by-id",
  addAttribute: buildingPrefix + "/add-attribute",
  getAllAttributes: buildingPrefix + "/get-all-attributes",
  editAttribute: buildingPrefix + "/edit-attribute",
  getAllLevelsGroupingWise:
    buildingPrefix + "/get-society-wise-connected-levels",
  addLevelData: buildingPrefix + "/add-levelData",
  getLevelwiseLevelData: buildingPrefix + "/get-all-levelData",
  getLevelDataByAddresswise: buildingPrefix + "/get-all-levelData-by-address",
  editLevel: buildingPrefix + "/edit-level",
  editLevelData: buildingPrefix + "/edit-levelData",
  getLevelDataFlow: buildingPrefix + "/get-all-structure-leveldata",
  deleteLevelData: buildingPrefix + "/delete-level-data",
  getAllZones: buildingPrefix + "/get-all-unique-attr",
};

// ** GROUP RELATED ENDPOINTS **
export const GroupEndPoints = {
  addGroup: buildingPrefix + "/add-group",
  getGroup: buildingPrefix + "/get-all-groups",
  getGroupDetails: buildingPrefix + "/get-group-by-id",
};

//** Role Related Endpoints **/

export const RoleEndPoints = {
  addRole: accessTypePrefix + "/add-accesstype",
  getAllRoles: accessTypePrefix + "/get-all-accesstypes",
  getRoleDetails: accessTypePrefix + "/get-accesstype-by-id",
  editRole: permissionPrefix + "/edit-permission",
  deleteRole: accessTypePrefix + "/delete-accesstype",
  editAccessType: accessTypePrefix + "/edit-accesstype",
};

// ** USER RELATED ENDPOINTS **
export const UserEndPoints = {
  getAllUsers: userPrefix + "/get-all-users",
  getAllUsersWithRole: userPrefix + "/get-all-users-with-role",
  getUserDetails: accessTypePrefix + "/get-user-by-id",
  changeUserRequestStatus:
    userAccessPrefix + "/approve-or-reject-pending-user-requests",
  rejectUserRequest: accessTypePrefix + "/reject-user-request",
  getUserRequest: accessTypePrefix + "/get-user-request",
  getVendorOrSubVendor: userPrefix + "/get-subvendors-and-main-vendor",
  getAllUserAccess: userAccessPrefix + "/get-all-useraccess",
  deleteUserAccess: userAccessPrefix + "/delete-useraccess",
  downloadUsersCSV: userPrefix + "/download-user-csv",
};

//** COMPLAINT RELATED ENDPOINTS */

export const ComplaintEndPoints = {
  addComplaint: complaintPrefix + "/add-complaint",
  getAllComplaints: complaintPrefix + "/get-all-complaints",
  getComplaintDetails: complaintPrefix + "/get-complaint-by-id",
  editComplaint: complaintPrefix + "/edit-complaint",
  deleteComplaint: complaintPrefix + "/delete-complaint",
  complaintCount: complaintPrefix + "/status-wise-complaint-count",
  complaintMetrics: complaintPrefix + "/get-complaint-metrics",
  getRecentComplaints: complaintPrefix + "/get-recent-complaints",
  getDeadlineRequests: complaintDeadlinePrefix + "/get-all-complaintdeadlines",
  approveOrRejectDeadlineRequest:
    complaintDeadlinePrefix + "/edit-complaintdeadline",
  getComplaintCsvData: complaintPrefix + "/complaints-csv-data",
  getVendorRating: vendorRatingPrefix + "/get-all-vendorratings",
  getVendorOverallAverageRating:
    vendorRatingPrefix + "/get-average-vendor-rating",
  getVendorRatingCSV: vendorRatingPrefix + "/get-vendor-rating-csv",
  getAllAcknowledgements: acknowledgementPrefix + "/get-all-acknowledges",
};

//** COMPLAINT STATUS ENDPOINTS */
export const ComplaintStatusEndPoints = {
  addStatus: complaintStatusPrefix + "/add-complaintstatus",
  getAllStatus: complaintStatusPrefix + "/get-all-complaintstatuss",
  editStatus: complaintStatusPrefix + "/edit-complaintstatus",
  deleteStatus: complaintStatusPrefix + "/delete-complaintstatus",
};

//**COMPLAINT RATING ENDPOINTS */
export const ComplaintRatingEndPoints = {
  addRating: ratingPrefix + "/add-rating",
  allRatings: ratingPrefix + "/get-all-ratings",
  editRating: ratingPrefix + "/edit-rating",
  deleteRating: ratingPrefix + "/delete-rating",
  addManuallyRating: vendorRatingManualPrefix + "/add-vendorrating",
};

//**MASTER LIFECYCLE ENDPOINTS */
export const MasterLifecycleEndPoints = {
  getAllLifecycle: masterLifecyclePrefix + "/get-all-masterlifecycles",
  addMasterLifeCycle: masterLifecyclePrefix + "/add-masterlifecycle",
  editMasterLifeCycle: masterLifecyclePrefix + "/edit-masterlifecycle",
  deleteMasterLifeCycle: masterLifecyclePrefix + "/delete-masterlifecycle",
};

//** COMPLAINT LIFECYCLE ENDPOINTS */
export const ComplaintLifecycleEndPoints = {
  getAllLifecycle: complaintLifeCyclePrefix + "/get-all-complaintlifecycles",
  editLifecycle: complaintLifeCyclePrefix + "/edit-complaintlifecycle",
  changePriority: complaintLifeCyclePrefix + "/change-priority",
  closeComplaint: complaintLifeCyclePrefix + "/close-complaint",
  cancelComplaint: complaintLifeCyclePrefix + "/cancel-complaint",
  cancelComplaintRequest: complaintLifeCyclePrefix + "/lifecycle-approval-request",
  resolveComplaint: complaintLifeCyclePrefix + "/resolve-complaint",
  notifyUser: complaintLifeCyclePrefix + "/notify-users",
  reopenComplaint: complaintLifeCyclePrefix + "/reopen-complaint",
  assignVendor: complaintLifeCyclePrefix + "/assign-vendor",
  raisePo: complaintLifeCyclePrefix + "/raise-po",
  extendDeadline: complaintLifeCyclePrefix + "/extend-deadline-request",
  typeOfComplaint: complaintLifeCyclePrefix + "/type-of-complaint",
  updateLevelData: complaintLifeCyclePrefix + "/update-level-data-of-complaint",
};

//** MIS ENDPOINTS */

export const MISEndPoints = {
  categoryWiseCount: complaintPrefix + "/category-wise-complaint-count",
  vendorAverageRating: vendorRatingPrefix + "/get-average-vendor-rating",
  statusWiseTimeAverage: complaintPrefix + "/last-status-wise-time-average",
  vendorSLAData: complaintPrefix + "/vendor-sla-graph",
  highestComplaintProperty:
    complaintPrefix + "/highest-complaint-raised-in-different-levelData",
  highestRatedVendor: complaintPrefix + "/highest-and-lowest-rated-vendor",
  totalComplaintCount: complaintPrefix + "/total-complaints-counts",
};

//*** VENDOR ENDPOINTS */

export const VendorEndpoints = {
  getVendors: vendorPrefix + "/get-vendors",
  getVendor: vendorPrefix + "/get-vendor",
  addVendor: vendorPrefix + "/add-vendor",
  editVendor: vendorPrefix + "/edit-vendor",
  assignVendor: vendorPrefix + "/assign-vendor",
};

//*** USER ACCESS ENDPOINTS */
export const UserAccessEndpoints = {
  addUserAccess: userAccessPrefix + "/add-useraccess",
  getUserAccesss: userAccessPrefix + "/get-all-useraccess",
  editUserAccess: userAccessPrefix + "/edit-useraccess",
  deleteUserAccess: userAccessPrefix + "/delete-useraccess",
  getVendorAdvanceAssignmentData:
    userAccessPrefix + "/get-vendor-advance-leveldata-access",
};

//*** Advance Level Data Setting ENDPOINTS */

export const AdvanceLevelDataSettingEndpoints = {
  getAdvanceLevelSetting:
    advanceLevelDataSettingPrefix + "/get-all-advanceleveldatasettings",
};

//**COMPLAINT Escalation ENDPOINTS */

export const ComplaintEscalationEndpoints = {
  getEscalation: escalationPrefix + "/get-all-escalations",
  addEscalation: escalationPrefix + "/add-escalation",
  getEscalationDetails: escalationPrefix + "/get-escalation-by-id",
  editEscalation: escalationPrefix + "/edit-escalation",
  addEscalationForLevelData: buildingPrefix + "/assign-multiple-escalation",
};

//**COMPLAINT PRIORITY CONTACT  ENDPOINTS */

export const PriorityContactEndpoints = {
  addPriorityContact: priorityPrefix + "/add-priority",
  getAllPriorityContact: priorityPrefix + "/get-all-prioritys",
  editPriorityContact: priorityPrefix + "/edit-priority",
  priorityContactDetails: priorityPrefix + "/get-priority-by-id",
};

//**CONNECTED LEVEL DATA ENDPOINTS */
export const ConnectedLevelDataEndpoints = {
  addConnectedLevelData: buildingPrefix + "/assign-multiple-connected-leveldata",
};
//**AWS  ENDPOINTS */
export const AwsS3Routes = {
  getPreSignedURL: awsPrefix + "/generate-presigned-url",
};

//**TOKEN ENDPOINTS */
export const TokenEndPoints = {
  getOtpTokens: authPrefix + "/get-all-otp-tokens",
  viewOtp: authPrefix + "/view-otp-from-token",
};

//**Advance Vendor Setting ENDPOINTS */
export const AdvanceVendorSettingEndpoints = {
  getAdvanceVendorSetting: vendorPrefix + "/get-advance-vendor-setting",
  addAdvanceVendorSetting: advanceVendorPrefix + "/add-advancevendor",
  getAllAdvanceVendorSetting: advanceVendorPrefix + "/get-all-advancevendors",
  exceptionLevelDataCount: buildingPrefix + "/exception-leveldata-counts",
};

//**NOTICE ENDPOINTS */
export const NoticeEndPoints = {
  addNotice: noticePrefix + "/add-notice",
  getNotices: noticePrefix + "/get-all-notices",
  getNoticeDetails: noticePrefix + "/get-notice-by-id",
  getAllNoticeTypes: noticePrefix + "/get-all-noticetypes",
  editNotice: noticePrefix + "/edit-notice",
  deleteNotice : noticePrefix + "/delete-notice"
};
export const HelpEndPoints = {
  getAllFaqs: faqPrefix + "/get-all-faq",
  getHelpDetail :faqPrefix + "/get-faq-by-id",
  addFaq:faqPrefix + "/add-faq"
};

export const ActivityEndPoints = {
  downloadLogs: activityPrefix + "/download-user-logs",
  allLogs: activityPrefix + "/get-all-user-logs",
  activity: activityPrefix + "/get-all-useraccess-activities",
};


export const ContactBookEndPoints = {
  getAllContactCategories: contactBookPrefix + "/get-all-contact-categories",
  addContactCategory: contactBookPrefix + "/add-contact-category",
  editContactCategory: contactBookPrefix + "/edit-contact-category",
  deleteContactCategory: contactBookPrefix + "/delete-contact-category",
  getAllContactSubcategories: contactBookPrefix + "/get-all-contact-subcategories",
  addContactSubcategory: contactBookPrefix + "/add-contact-subcategory",
  editContactSubcategory: contactBookPrefix + "/edit-contact-subcategory",
  deleteContactSubcategory: contactBookPrefix + "/delete-contact-subcategory",
  getAllContacts: contactBookPrefix + "/get-all-contacts",
  addContact: contactBookPrefix + "/add-contact",
  deleteContact: contactBookPrefix + "/delete-contact", 
  editContact: contactBookPrefix + "/edit-contact",
};


export const MisNewEndPoints = {
  getComplaintOverviewGraph: complaintPrefix + "/highest-complaint-raised-in-different-levelData",
  getComplaintOverviewCount: complaintPrefix + "/complaint-mis-counts",
  byMonthGraph: complaintPrefix + "/month-wise-complaintdata",
  misZoneListTable: complaintPrefix + "/attribute-wise-complaint-mis",
  getComplainerWiseComplaintMis: complaintPrefix + "/get-complainer-wise-complaints",
  dueBarGraphComplaintMis: complaintPrefix + "/status-wise-date-range-graph",
  dueBarGraphbyVendorComplaintMis: complaintPrefix + "/vendor-day-wise-complaint-count",
  barGraphByZoneComplaintMis: complaintPrefix + "/attribute-wise-weekly-graph",
  levelWiseRatingGraphdata: complaintPrefix +"/level-data-wise-feedback-rating",
  getComplaintsForMisGraph : complaintPrefix+ "/get-complaints-for-graphs",
  vendorFeedbackRatingGraph : complaintPrefix + "/vendor-feedback-rating",
  getComplaintsAgeWiseGraph : complaintPrefix + "/age-wise-graph",
  saveMisSettings: misSettingsPrefix + "/add-missetting",
  getMisSettings: misSettingsPrefix + "/get-all-missettings",
};

export const HolidayMappingEndPoints = {
  addHoliday: holidayMappingPrefix + "/add-bulk-holidays",
  addIndividualHoliday: holidayMappingPrefix + "/add-individual-holiday",
  getAllHolidays: holidayMappingPrefix + "/get-all-holidays",
  deleteHoliday: holidayMappingPrefix + "/delete-holiday",
  editHoliday: holidayMappingPrefix + "/edit-holiday",
  getHolidaySettings: holidayMappingPrefix + "/get-holiday-settings",
  saveHolidaySettings: holidayMappingPrefix + "/save-holiday-settings",
};

export const RatingColorEndPoints = {
  getRatingColorSettings: ratingColorPrefix + "/get-all-ratingColors",
  saveRatingColorSettings: ratingColorPrefix + "/add-ratingColor",
  deleteRatingColorSettings: ratingColorPrefix + "/delete-ratingColor",
  editRatingColorSettings: ratingColorPrefix + "/edit-ratingColor",
};
export const SurveyEndPoints = {
  getSurvey: surveyPrefix + "/get-all-surveys",
  getSurveyDetails: surveyPrefix + "/get-survey-by-id",
  getSurveyCSV: surveyPrefix + "/download-csv",
  getMISDashboard: surveyPrefix + "/get-mis-dashboard",
  getSurveyStats: surveyPrefix + "/get-survey-stats",
  getSurveyAddress: surveyAddressPrefix + "/get-all-surveyaddresss",
  editSurveyAddress: surveyAddressPrefix + "/edit-surveyaddress",
  addSurveyAddress: surveyAddressPrefix + "/add-surveyaddress", 
  deleteSurveyAddress: surveyAddressPrefix + "/delete-surveyaddress"

};

export const SurveyorTargetEndPoints = {
  addSurveyorTarget: surveyorTargetPrefix + "/add-surveyortarget",
  editSurveyorTarget: surveyorTargetPrefix + "/edit-surveyortarget",
  getSurveyorTargets: surveyorTargetPrefix + "/get-all-surveyortargets",
  getSurveyorTargetById: surveyorTargetPrefix + "/get-surveyortarget-by-id",
  deleteSurveyorTarget: surveyorTargetPrefix + "/delete-surveyortarget",
};